import React from 'react';
import { Navigate } from "react-router-dom";
import {
  ASSET_READ,
  USER_READ,
  ORGANIZATION_READ,
  SERVICE_READ,
  MAINTENANCE_READ,
  ROLE_READ,
  VENDOR_READ,
  LOCATION_READ,
  SERVICE_REQUEST_READ,
  PROCUREMENT_REQUEST_READ,
  ASSET_TRANSFER,
  REPORT_VIEW,
  COST_REPORT_VIEW,
  INVITATION_READ,
  METER_READ,
  ORG_AGGREGATE_VIEW,
  MATERIOVIGILANCE_READ,
  DOCUMENT_VAULT_READ,
} from '../constants/permissions';

// Global Organizations
import GlobalDashboard from '../Page/Global/GlobalDashboard';
import GlobalAssets from '../Page/Global/GlobalAssets';

// Calendar
import Calendar from '../Pages/Calendar/index';

// Chat
import Chat from '../Pages/Chat/Chat';

// Email
import Inbox from '../Pages/Email/Inbox';
import ReadEmail from '../Pages/Email/ReadEmail';

// Ecommerce
import AddProduct from '../Pages/Ecommerce/AddProduct';
import Cart from '../Pages/Ecommerce/Cart';
import Checkout from '../Pages/Ecommerce/Checkout';
import Customers from '../Pages/Ecommerce/EcommerceCustomer/Customers';
import Orders from '../Pages/Ecommerce/EcommerceOrder/Orders';
import ProductDetail from '../Pages/Ecommerce/ProductDetail';
import Product from '../Pages/Ecommerce/Products';
import Shops from '../Pages/Ecommerce/Shops';

// Invoices
import InvoicesDetail from '../Pages/Invoices/InvoiceDetails';
import InvoicesList from '../Pages/Invoices/InvoicesList';

// Contact
import UserGrid from '../Pages/Contacts/UserGrid';
import UserList from '../Pages/Contacts/UserList';
import ContactUserProfile from '../Pages/Contacts/UserProfile';

// UiElememnt
import UiAlerts from '../Pages/UIElements/UiAlerts';
import UiButtons from '../Pages/UIElements/UiButtons';
import UiCards from '../Pages/UIElements/UiCards';
import UiCarousel from '../Pages/UIElements/UiCarousel';
import UiDropdowns from '../Pages/UIElements/UiDropdowns';
import UiGrid from '../Pages/UIElements/UiGrid';
import UiImages from '../Pages/UIElements/UiImages';
import UiModals from '../Pages/UIElements/UiModals';
import UiOffcanvas from '../Pages/UIElements/UiOffcanvas';
import UiPlaceholders from '../Pages/UIElements/UiPlaceholders';
import UiProgressBars from '../Pages/UIElements/UiProgressBars';
import UiTabs from '../Pages/UIElements/UiTabs&Accordions';
import UiTypography from '../Pages/UIElements/UiTypography';
import UiVideo from '../Pages/UIElements/UiVideo';
import UiGeneral from '../Pages/UIElements/UiGeneral';
import UiColors from '../Pages/UIElements/UiColors';

// Extended Element
import ExLightbox from '../Pages/ExtendedElement/ExLightbox';
import ExRangSlider from '../Pages/ExtendedElement/ExRangeSlider';
import ExRating from '../Pages/ExtendedElement/ExRating';
import ExNotification from '../Pages/ExtendedElement/ExNotification';

// Forms
import BasicElements from '../Pages/Forms/BasicElements';
import Validation from '../Pages/Forms/Validation';
import AdvancedPlugins from '../Pages/Forms/AdvancedPlugins';
import Editors from '../Pages/Forms/Editors';
import FileUpload from '../Pages/Forms/FileUpload';
import Wizard from '../Pages/Forms/Wizard';
import Mask from '../Pages/Forms/Mask';

// Tables
import BootstrapBasic from '../Pages/Tables/BootstrapBasic';
import AdvanceTable from '../Pages/Tables/AdvanceTable';

// Charts
import ApexCharts from '../Pages/Charts/ApexCharts';
import ChartjsCharts from '../Pages/Charts/Chartjs';

// Icons
import FeatherIcons from '../Pages/Icons/Feathericon';
import BoxIcons from '../Pages/Icons/Boxicons';
import MaterialDesignIcons from '../Pages/Icons/MaterialDesign';
import DripIcons from '../Pages/Icons/Dripicons';
import FontAwesomeIcons from '../Pages/Icons/FontAwesome';

// Maps
import GoogleMaps from '../Pages/Maps/GoogleMaps';
import VectorMaps from '../Pages/Maps/VectorMaps';
import LeafletMaps from '../Pages/Maps/LeafletMaps';

// Inner Authentication Pages
import InnerLogin from "../Pages/InnerAuthPages/login";
import InnerRegister from "../Pages/InnerAuthPages/Register";
import RecoverPassword from "../Pages/InnerAuthPages/RecoverPassword";
import LockScreen from "../Pages/InnerAuthPages/LockScreen";
import InnerLogout from "../Pages/InnerAuthPages/Logout";
import ConfirmMail from "../Pages/InnerAuthPages/ConfirmMail";
import EmailVerification from "../Pages/InnerAuthPages/EmailVerification";
import TwoStepVerification from "../Pages/InnerAuthPages/TwoStepVerification";

// Utility Pages
import StarterPage from '../Pages/Utility/pages-starter';
import MaintenancePage from '../Pages/Utility/pages-maintenance';
import ComingSoonPage from '../Pages/Utility/pages-comingsoon';
import TimelinePage from '../Pages/Utility/pages-timeline';
import FaqsPage from '../Pages/Utility/pages-faqs';
import PricingPage from '../Pages/Utility/pages-pricing';
import Error404 from '../Pages/Utility/pages-404';
import Error500 from '../Pages/Utility/pages-500';

// Import Authentication pages
import Login from "../Pages/Authentication/Login";
import SSOCallback from "../Pages/Authentication/SSOCallback";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import ResetPasswordPage from "../Pages/Authentication/ResetPassword";
import Logout from "../Pages/Authentication/Logout";
import Register from "../Pages/Authentication/Register";
import UserProfile from "../Pages/Authentication/user-profile";
import Organization from '../Page/Organization';
import UserManagement from '../Page/UserManagement';
import Assets from '../Page/Assets';
import Reactive from '../Page/Reactive';
import Location from '../Page/Location';
import Issues from '../Page/Issues';
import Forms from '../Page/Forms';
import CalibrationDetail from '../Page/Details/CalibrationDetail';
import Vendor from '../Page/Vendor';
import Tools from '../Page/Tools';
import Testing from '../Page/Testing';
import Routine from '../Page/Routine';
import Recall from '../Page/Recall';

import SpareParts from '../Page/SpareParts';
import Contracts from '../Page/Contracts';
import Schedule from '../Page/Schedule';
import AssetDetail from '../Page/AssetDetail';
import AppInstallPrompt from '../Page/AppInstallPrompt';
import PlanningLocked from '../Page/PlanningLocked';
import Compliance from '../Page/Compliance';
import KnowledgeHub from '../Page/KnowledgeHub';
import ReportingLocked from '../Page/ReportingLocked';
import ReportingDashboard from '../Page/Reporting/ReportingDashboard';
import MaintenanceSpendByAssetTable from '../Page/Reporting/MaintenanceSpendByAssetTable';
import ServiceRequests from '../Page/ServiceRequests';
import PlanningPurchasing from '../Page/PlanningPurchasing';
import Meters from '../Page/Meters';
import PendingApproval from '../Page/PendingApproval';
import InviteAccept from '../Pages/Authentication/InviteAccept';
import Settings from '../Page/Settings';

const authProtectedRoutes = [

  // Organization management - requires organization:read permission
  { path: "/organizations", component: <Organization />, permission: ORGANIZATION_READ },

  // Settings page (all settings tabs)
  { path: "/settings", component: <Settings /> },
  { path: "/settings/my-account", component: <Settings /> },
  { path: "/settings/organization", component: <Settings /> },
  { path: "/settings/categories", component: <Settings /> },
  { path: "/settings/work-order-categories", component: <Settings /> },
  { path: "/settings/asset-categories", component: <Settings /> },
  { path: "/settings/spare-part-types", component: <Settings /> },
  { path: "/settings/contract-categories", component: <Settings /> },
  { path: "/settings/contracts", component: <Settings />, permission: MAINTENANCE_READ },
  { path: "/settings/users", component: <Settings /> },
  { path: "/settings/teams", component: <Settings /> },
  { path: "/settings/vendors", component: <Settings /> },
  { path: "/settings/invitations", component: <Settings /> },
  { path: "/settings/roles", component: <Settings /> },
  { path: "/settings/escalations", component: <Settings /> },
  { path: "/settings/custom-fields", component: <Settings /> },
  { path: "/settings/asset-custom-fields", component: <Settings /> },

  // Legacy redirects
  { path: "/users", component: <Navigate to="/settings/users" /> },
  { path: "/invitations", component: <Navigate to="/settings/invitations" /> },
  { path: "/roles", component: <Navigate to="/settings/roles" /> },
  { path: "/vendors", component: <Navigate to="/settings/vendors" /> },
  { path: "/categories", component: <Navigate to="/settings/work-order-categories" /> },
  { path: "/asset-types", component: <Navigate to="/settings/asset-categories" /> },
  { path: "/settings/asset-types", component: <Navigate to="/settings/asset-categories" /> },

  // Asset management - requires asset:read permission
  { path: "/assets", component: <Assets />, permission: ASSET_READ },
  { path: "/asset-detail/:uuid", component: <AssetDetail />, permission: ASSET_READ },
  { path: "/tools", component: <Tools />, permission: ASSET_READ },
  { path: "/testing", component: <Testing />, permission: ASSET_READ },
  { path: "/routine", component: <Routine />, permission: MAINTENANCE_READ },
  { path: "/recall", component: <Recall />, permission: MAINTENANCE_READ },
  { path: "/spare-parts", component: <SpareParts />, permission: ASSET_READ },

  // Meter management - requires meter:read permission
  { path: "/meters", component: <Meters />, permission: METER_READ },

  // Service management - requires service:read permission
  { path: "/service-contracts", component: <Navigate to="/settings/contracts" /> },
  { path: "/settings/service-contracts", component: <Navigate to="/settings/contracts" /> },
  { path: "/schedule", component: <Schedule />, permission: SERVICE_READ },
  { path: "/reactive", component: <Reactive />, permission: SERVICE_READ },
  { path: "/preventive", component: <Navigate to="/reactive?workType=PREVENTIVE" /> },  // Legacy redirect → Preventive view
  { path: "/calendar-view", component: <Navigate to="/reactive" /> },  // Calendar merged into Work Orders as a view toggle

  // Location management - requires location:read permission
  { path: "/locations", component: <Location />, permission: LOCATION_READ },

  // Admin-only routes
  { path: "/dynamic-values", component: <Issues />, adminOnly: true },

  // Pending approval (protected - shows to authenticated users with pending org)
  { path: "/pending-approval", component: <PendingApproval /> },

  // Service requests - requires service-request:read permission
  { path: "/service-requests", component: <ServiceRequests />, permission: SERVICE_REQUEST_READ },

  // Legacy requests - requires service:read permission
  { path: "/requests", component: <Forms />, permission: SERVICE_READ },
  { path: "/calibration-details", component: <CalibrationDetail />, permission: SERVICE_READ },

  // Reporting - requires report:view permission
  { path: "/reporting", component: <ReportingDashboard />, permission: REPORT_VIEW },
  // Expanded table view of Maintenance Spend by Asset (drill-down from Asset Health widget)
  { path: "/reporting/asset-spend", component: <MaintenanceSpendByAssetTable />, permission: COST_REPORT_VIEW },

  // Multi-org aggregate (Global View). Permission-gated by org:aggregate-view;
  // in practice the page is reached only when the user has aggregate-view in
  // 2+ of their org memberships (the switcher hides the entry otherwise).
  // requireActiveOrg=false because these routes are *meant* to render in
  // Global View — the default guard would bounce the user back here in a loop.
  { path: "/app/global/dashboard", component: <GlobalDashboard />, permission: ORG_AGGREGATE_VIEW, requireActiveOrg: false },
  { path: "/app/global/assets", component: <GlobalAssets />, permission: ORG_AGGREGATE_VIEW, requireActiveOrg: false },

  // Planning: procurement requests, purchase orders, analytics and the asset-transfer queue
  // (tabbed). The former /equipment page that hosted the transfer queue has been retired.
  { path: "/planning", component: <PlanningPurchasing />, permissions: [PROCUREMENT_REQUEST_READ, ASSET_TRANSFER] },

  // Knowledge Hub — central documents view, aggregating every file uploaded across modules.
  { path: "/knowledge-hub", component: <Navigate to="/knowledge-hub/documents" replace /> },
  { path: "/knowledge-hub/documents", component: <KnowledgeHub />, permission: DOCUMENT_VAULT_READ },

  // Compliance — Materiovigilance + Certificates tabs
  { path: "/compliance", component: <Navigate to="/compliance/materiovigilance" replace /> },
  { path: "/compliance/materiovigilance", component: <Compliance />, permission: MATERIOVIGILANCE_READ },
  { path: "/compliance/certificates", component: <Compliance />, permission: DOCUMENT_VAULT_READ },

  // Profile
  { path: "/userprofile", component: <UserProfile /> },

  // Calendar
  { path: "/apps-calendar", component: <Calendar /> },


  // Chat
  { path: "/apps-chat", component: <Chat /> },


  // Email
  { path: "/email-inbox", component: <Inbox /> },
  { path: "/email-read", component: <ReadEmail /> },


  // Ecommerce
  { path: "/ecommerce-product-detail", component: <ProductDetail /> },
  { path: "/ecommerce-products", component: <Product /> },
  { path: "/ecommerce-orders", component: <Orders /> },
  { path: "/ecommerce-customers", component: <Customers /> },
  { path: "/ecommerce-cart", component: <Cart /> },
  { path: "/ecommerce-checkout", component: <Checkout /> },
  { path: "/ecommerce-shops", component: <Shops /> },
  { path: "/ecommerce-add-product", component: <AddProduct /> },


  // Invoices
  { path: "/invoices-detail", component: <InvoicesDetail /> },
  { path: "/invoices-list", component: <InvoicesList /> },


  // Contact
  { path: "/contacts-grid", component: <UserGrid /> },
  { path: "/contacts-list", component: <UserList /> },
  { path: "/contacts-profile", component: <ContactUserProfile /> },


  // Utility Pages
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/pages-timeline", component: <TimelinePage /> },
  { path: "/pages-faqs", component: <FaqsPage /> },
  { path: "/pages-pricing", component: <PricingPage /> },


  // UiElement
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdowns /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-progressbars", component: <UiProgressBars /> },
  { path: "/ui-tabs-accordions", component: <UiTabs /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-colors", component: <UiColors /> },


  // Extended Element
  { path: "/extended-lightbox", component: <ExLightbox /> },
  { path: "/extended-rangeslider", component: <ExRangSlider /> },
  { path: "/extended-rating", component: <ExRating /> },
  { path: "/extended-notifications", component: <ExNotification /> },


  // Forms
  { path: "/form-elements", component: <BasicElements /> },
  { path: "/form-validation", component: <Validation /> },
  { path: "/form-advanced", component: <AdvancedPlugins /> },
  { path: "/form-editors", component: <Editors /> },
  { path: "/form-uploads", component: <FileUpload /> },
  { path: "/form-wizard", component: <Wizard /> },
  { path: "/form-mask", component: <Mask /> },


  // Tables
  { path: "/tables-basic", component: <BootstrapBasic /> },
  { path: "/tables-advanced", component: <AdvanceTable /> },


  // Charts
  { path: "/charts-apex", component: <ApexCharts /> },
  { path: "/charts-chartjs", component: <ChartjsCharts /> },


  // Icons
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesignIcons /> },
  { path: "/icons-dripicons", component: <DripIcons /> },
  { path: "/icons-fontawesome", component: <FontAwesomeIcons /> },


  // Maps
  { path: "/maps-google", component: <GoogleMaps /> },
  { path: "/maps-vector", component: <VectorMaps /> },
  { path: "/maps-leaflet", component: <LeafletMaps /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/reactive" />,
  },

];

const publicRoutes = [

  // Deep link route for NFC/RFID tags (public - handles auth internally)
  { path: "/assets/:uuid", component: <AppInstallPrompt /> },

  // Invitation acceptance (public)
  { path: "/invite/:token", component: <InviteAccept /> },
  { path: "/invite", component: <InviteAccept /> },

  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  // SSO handshake return — backend sets cookies then 302s here (public; hydrates via /auth/me).
  { path: "/auth/sso/callback", component: <SSOCallback /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  // Token-verified reset landing page — opened from the link in the reset email (?token=...).
  { path: "/reset-password", component: <ResetPasswordPage /> },
  { path: "/register", component: <Register /> },

  // Inner Auth Pages  
  { path: "/auth-login", component: <InnerLogin /> },
  { path: "/auth-register", component: <InnerRegister /> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-logout", component: <InnerLogout /> },
  { path: "/auth-confirm-mail", component: <ConfirmMail /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-two-step-verification", component: <TwoStepVerification /> },

  // Utility Pages
  { path: "/pages-maintenance", component: <MaintenancePage /> },
  { path: "/pages-comingsoon", component: <ComingSoonPage /> },
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
];

export { authProtectedRoutes, publicRoutes };
